/* eslint-disable eqeqeq */
import React from 'react'
import '../styles/loader.css'
class Loader extends React.Component {
    constructor(props){
        super(props)
        // this.whiteStyle = {border : '2px solid white', top : '-2px', borderColor: 'white transparent transparent transparent'}
        this.style = {}
        if (this.props.isWhite){
            this.style = {border : '2px solid white', top : '-2px', borderColor: 'white transparent transparent transparent'}
        } else if (this.props.isBlack){
            this.style = {border : '2px solid black', top : '-2px', borderColor: 'black transparent transparent transparent', height : '28px', width : '28px'}

        }
    }
    
    render(){
            return (
                <div style={this.props.style != undefined ? this.props.style : {}} className="loader_chat_container">
                    <div className="lds-ring loader_container">
                        <div style={this.style}></div>
                        <div style={this.style}></div>
                        <div style={this.style}></div>
                        <div style={this.style}></div>
                        {/* <p className="loader_text">{this.props.text}</p> */}
                    </div>
                </div>
            )   
    }
}
export default Loader
